import { useTranslation } from 'react-i18next'
import { FilterAltOutlined, KeyboardArrowDown } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'

import { AppLoader } from '@components/AppLoader'
import { RedirectToConfigButton } from '@components/RedirectToConfigButton'

interface SearchAssistantAccordionProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  title: string
  expanded?: boolean
  disabled?: boolean
  loading?: boolean
  searchAssistantId?: string | number
  onChange?: (event: React.SyntheticEvent, isExpanded: boolean) => void
}

export const SearchAssistantAccordion: React.FC<SearchAssistantAccordionProps> = props => {
  const { title, children, expanded, disabled, loading, searchAssistantId, onChange } = props

  const { t } = useTranslation()

  const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    if (!loading) {
      onChange?.(event, isExpanded)
    }
  }

  return (
    <Accordion
      disableGutters
      square
      data-component='SearchAssistantAccordion'
      disabled={disabled}
      elevation={0}
      expanded={expanded}
      sx={{
        '&.MuiAccordion-root': {
          backgroundColor: theme => theme.palette.background.main,
        },
      }}
      onChange={handleChange}
    >
      <AccordionSummary
        expandIcon={!expanded && loading ? <AppLoader size='1rem' /> : <KeyboardArrowDown />}
        sx={{
          '&.MuiAccordionSummary-root': {
            justifyContent: 'flex-start',
            minHeight: 34,
            paddingInline: 1,
            columnGap: 1,
          },
          '& .MuiAccordionSummary-content': {
            alignItems: 'center',
            columnGap: 1,
            margin: 0,
            flexGrow: 0,
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
          },
        }}
      >
        <FilterAltOutlined htmlColor='rgb(117, 117, 117)' />
        {searchAssistantId && (
          <RedirectToConfigButton
            searchAssistantId={searchAssistantId}
            title={t('searchAssistant.openEditPageButtonText')}
            type='search-assistant'
          />
        )}
        <Typography color='rgb(117, 117, 117)' fontSize={15}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ '&.MuiAccordionDetails-root': { padding: 0 } }}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

SearchAssistantAccordion.displayName = 'SearchAssistantAccordion'
